import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  DocumentReferenceEntityType,
  entityName,
  NdaTemplateDocumentReference,
} from '@qtek/shared/models';
import { DocumentReferenceService } from '../core/document-reference.service';

@Injectable({ providedIn: 'root' })
export class NdaTemplateDocumentReferenceService extends DocumentReferenceService<NdaTemplateDocumentReference> {
  protected http = inject(HttpClient);
  protected entityName: entityName = 'NdaTemplateDocumentReference';
  readonly entityType = DocumentReferenceEntityType.NDA_TEMPLATE;
}
